<div class="chart">
    <app-generic-chart-card 
      [title]="'DASHBOARD.CHARTS.MALE_STUDENTS_REPORTS' | translate" 
      [contentTemplate]="activeStudentsContent" 
      [headerTemplate]="activeStudentsHeader"
      [filterTemplate]="filters" 
      [caller]="caller" 
      [showReloadButton]="true"
      [showFiltersButton]="true"
      [formGroup]="form"
      [filterSearchKey]="'studentSearch'">
        <ng-template #activeStudentsHeader let-data>
          <app-chart-card-header-data [headerData]="headerData" [filters]="chartfilters"></app-chart-card-header-data>
        </ng-template>
        <ng-template #activeStudentsContent let-data>
          <app-bar-chart
            [data]="data"
            [showLegend]="data ?? false"
            [legendPosition]="'right'"
            [isStacked]="true"
            [labels]="['DASHBOARD.CHARTS.MALE_STUDENTS' | translate , 'DASHBOARD.CHARTS.FEMALE_STUDENTS' | translate ]">
          </app-bar-chart>
        </ng-template>
        <ng-template #filters>
          <app-date-range
            [label]="'PLACEHOLDERS.DATE' | translate"
            formControlName="date">
          </app-date-range>
        </ng-template>
    </app-generic-chart-card>
  </div> 